import i18n from "i18next";
import { initReactI18next } from "react-i18next";

import { DEFAULT_LANGUAGE, LANGUAGES, NAMESPACES } from "./languages";

// English is bundled so the default site renders without an extra request.
import enCommon from "../locales/en/common.json";
import enHome from "../locales/en/home.json";
import enAbout from "../locales/en/about.json";
import enProjects from "../locales/en/projects.json";
import enResources from "../locales/en/resources.json";
import enArticles from "../locales/en/articles.json";
import enContact from "../locales/en/contact.json";

// Other languages are split into their own chunks and loaded on demand.
const lazyBackend = {
  type: "backend",
  read(language, namespace, callback) {
    import(`../locales/${language}/${namespace}.json`)
      .then((module) => callback(null, module.default))
      .catch((error) => callback(error, null));
  },
};

export function initI18n(language) {
  return i18n
    .use(lazyBackend)
    .use(initReactI18next)
    .init({
      lng: language,
      fallbackLng: DEFAULT_LANGUAGE,
      supportedLngs: LANGUAGES.map((l) => l.code),
      ns: NAMESPACES,
      defaultNS: "common",
      partialBundledLanguages: true,
      resources: {
        en: {
          common: enCommon,
          home: enHome,
          about: enAbout,
          projects: enProjects,
          resources: enResources,
          articles: enArticles,
          contact: enContact,
        },
      },
      interpolation: { escapeValue: false }, // React already escapes
      returnEmptyString: false,
      react: { useSuspense: false },
    });
}

export default i18n;
